<script setup lang="ts">
import { Swiper, SwiperSlide } from "swiper/vue";
import { FreeMode, Mousewheel } from "swiper/modules";
import { getCategoryUrl } from "@shopware/helpers";

defineEmits(["onNavigation"]);

const { baseCategories } = useShopwareCategories();

const swiperModules = [FreeMode, Mousewheel];

const { fullPath } = useRoute();
</script>

<template>
	<Swiper
		v-if="!!baseCategories"
		space-between="8px"
		slides-per-view="auto"
		free-mode
		mousewheel
		:modules="swiperModules"
		class="!-mx-6 !px-6 md:!mx-0 md:!px-0"
		wrapper-class="flex"
	>
		<SwiperSlide :key="category.id" v-for="category in baseCategories" class="max-w-min mr-2">
			<NuxtLink :to="`${getCategoryUrl(category as any)}`" @click="$emit('onNavigation')">
				<KippieButton
					pill
					size="small"
					:color="fullPath.includes(getCategoryUrl(category as any)) ? 'black' : 'white'"
					fake
				>
					{{ category.translated?.name }}
				</KippieButton>
			</NuxtLink>
		</SwiperSlide>
	</Swiper>
</template>
